import React, { useCallback, useMemo, useState } from 'react';

import {
  Typography,
  Paper,
  CardHeader,
  CardContent,
  DateRangeSelector,
  getDateRanges,
  RangeTypeWithCustom,
} from '@occc/ui-design-system';
import { calcDateTime, DateTimeFormat, DurationUnit, formatDateTime } from '@occc-app/lib/date';

import { AudienceSizeChartContainer } from './AudienceSizeChart/AudienceSizeChartContainer';

type DateRange = {
  startDate: Date;
  endDate: Date;
};

interface IAudienceSizeOverTimeProps {
  audienceId: string;
}

export const AudienceSizeOverTime: React.FC<IAudienceSizeOverTimeProps> = ({ audienceId }) => {
  const [dateRange, setDateRange] = useState<DateRange>(() => {
    const now = new Date();
    return {
      startDate: calcDateTime(now, 'sub', 1, 'week'),
      endDate: calcDateTime(now, 'sub', 1, 'day'),
    };
  });
  const [interval, setInterval] = useState<DurationUnit>('day');
  const dateRanges = useMemo(() => getDateRanges(), []);

  const onDateRangeChange = useCallback(
    ({ startDate, endDate }: DateRange, rangeType: RangeTypeWithCustom) => {
      setInterval(['today', 'yesterday'].includes(rangeType) ? 'hour' : 'day');
      setDateRange({ startDate, endDate });
    },
    [],
  );

  return (
    <Paper>
      <CardHeader
        title={
          <Typography variant='h6' component='h4'>
            Size of Audience over time
          </Typography>
        }
        action={
          <DateRangeSelector
            value={dateRange}
            onChange={onDateRangeChange}
            dateRangePresets={[
              dateRanges.yesterday,
              { ...dateRanges.last_7_days, label: 'Previous 7 Days' },
              { ...dateRanges.last_30_days, label: 'Previous 30 Days' },
              dateRanges.last_365_days,
            ]}
          />
        }
      />
      <CardContent>
        <AudienceSizeChartContainer
          audienceId={audienceId}
          startDate={formatDateTime(dateRange.startDate, DateTimeFormat.Default)}
          endDate={formatDateTime(dateRange.endDate, DateTimeFormat.Default)}
          interval={interval}
        />
      </CardContent>
    </Paper>
  );
};
